// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore/lite";
import { getStorage } from "firebase/storage"; // ✅ Import Firebase Storage

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB9r4v-6c43Iu1AoMI9Yp6aMxVqZ_cNR9I",
  authDomain: "metropolitan-sacco-admin.firebaseapp.com",
  projectId: "metropolitan-sacco-admin",
  storageBucket: "metropolitan-sacco-admin.appspot.com", // ✅ Fix the storageBucket URL
  messagingSenderId: "682671485467",
  appId: "1:682671485467:web:357508c0b14d2f7e983ebe",
  measurementId: "G-RLWJN3PBSC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const authentication = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); // ✅ Initialize Firebase Storage